<div class="w-full" [class.pointer-events-none]="readonly()">
  @if (field().type === 'heading' ||
  field().type === 'paragraph' ||
  field().type === 'divider' ||
  field().type === 'spacer') {
    @switch (field().type) {
      @case ('heading') {
        @if (headingLevel() === 2) {
          <h2
            class="w-full text-xl tracking-tight text-slate-950"
            [class.text-left]="headingAlignment() === 'left'"
            [class.text-center]="headingAlignment() === 'center'"
            [class.text-right]="headingAlignment() === 'right'"
            [style.color]="headingColor()"
            [class.normal]="headingFontStyle() === 'normal'"
            [class.italic]="headingFontStyle() === 'italic'"
            [style.font-family]="headingFontFamily()"
            [style.font-weight]="headingFontWeight()">
            {{ field().label }}
          </h2>
        } @else if (headingLevel() === 3) {
          <h3
            class="w-full text-lg tracking-tight text-slate-950"
            [class.text-left]="headingAlignment() === 'left'"
            [class.text-center]="headingAlignment() === 'center'"
            [class.text-right]="headingAlignment() === 'right'"
            [class.normal]="headingFontStyle() === 'normal'"
            [class.italic]="headingFontStyle() === 'italic'"
            [style.font-weight]="headingFontWeight()">
            {{ field().label }}
          </h3>
        } @else if (headingLevel() === 4) {
          <h4
            class="w-full text-base tracking-tight text-slate-950"
            [class.text-left]="headingAlignment() === 'left'"
            [class.text-center]="headingAlignment() === 'center'"
            [class.text-right]="headingAlignment() === 'right'"
            [class.normal]="headingFontStyle() === 'normal'"
            [class.italic]="headingFontStyle() === 'italic'"
            [style.font-weight]="headingFontWeight()">
            {{ field().label }}
          </h4>
        } @else {
          <h4
            class="text-sm tracking-tight text-slate-950"
            [class.text-left]="headingAlignment() === 'left'"
            [class.text-center]="headingAlignment() === 'center'"
            [class.text-right]="headingAlignment() === 'right'"
            [class.normal]="headingFontStyle() === 'normal'"
            [class.italic]="headingFontStyle() === 'italic'"
            [style.font-weight]="headingFontWeight()">
            {{ field().label }}
          </h4>
        }
      }
      @case ('paragraph') {
        <p
          class="w-full whitespace-pre-wrap leading-6"
          [class.text-lg]="paragraphLevel() === 2"
          [class.text-base]="paragraphLevel() === 3"
          [class.text-sm]="paragraphLevel() === 4"
          [class.text-xs]="paragraphLevel() === 5"
          [class.text-left]="paragraphAlignment() === 'left'"
          [class.text-center]="paragraphAlignment() === 'center'"
          [class.text-right]="paragraphAlignment() === 'right'"
          [class.normal]="paragraphFontStyle() === 'normal'"
          [class.italic]="paragraphFontStyle() === 'italic'"
          [style.font-family]="paragraphFontFamily()"
          [style.color]="paragraphColor()"
          [style.font-weight]="paragraphFontWeight()">
          {{ field().label }}
        </p>
      }
      @case ('divider') {
        <hr
          class="my-1 w-full border-0"
          [style.border-top-style]="dividerStyle()"
          [style.border-top-width]="dividerThickness() + 'px'"
          [style.opacity]="dividerOpacity() / 100"
          [style.border-top-color]="dividerColor()" />
      }
      @case ('spacer') {
        <div
          class="w-full rounded-lg border border-dashed border-slate-200 bg-slate-50/80"
          [class.h-3]="spacerSize() === 'sm'"
          [class.h-6]="spacerSize() === 'md'"
          [class.h-10]="spacerSize() === 'lg'"
          aria-hidden="true"></div>
      }
    }
  } @else if (isRatingField()) {
    <div class="w-full">
      @if (hasAnswerBinding()) {
        <app-rating
          [formField]="$any(answerField())"
          [label]="field().label"
          [helpText]="field().helpText ?? ''"
          [scaleMin]="1"
          [scaleMax]="ratingMax()" />
      } @else {
        <app-rating
          [label]="field().label"
          [helpText]="field().helpText ?? ''"
          [scaleMin]="1"
          [scaleMax]="ratingMax()"
          [required]="isRequired()"
          [value]="null"
          [readonly]="readonly()" />
      }
    </div>
  } @else {
    @switch (field().type) {
      @case ('text') {
        @if (hasAnswerBinding()) {
          <lib-signal-text-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="field().placeholder ?? ''"
            [hint]="field().helpText ?? ''"
            [appearance]="inputAppearance()"
            [showClearButton]="false" />
        } @else {
          <lib-signal-text-field
            [label]="field().label"
            [placeholder]="field().placeholder ?? ''"
            [value]="textDefaultValue()"
            [hint]="field().helpText ?? ''"
            [readonly]="readonly()"
            [appearance]="inputAppearance()"
            [showClearButton]="false" />
        }
      }
      @case ('textarea') {
        <div class="w-full">
          @if (hasAnswerBinding()) {
            <lib-signal-textarea
              [formField]="$any(answerField())"
              [label]="field().label"
              [placeholder]="placeholder()"
              [hint]="field().helpText || ''"
              [appearance]="inputAppearance()"
              [rows]="textareaRows()"
              [resize]="textareaResize()" />
          } @else {
            <lib-signal-textarea
              [label]="field().label"
              [placeholder]="placeholder()"
              [value]="textareaDefaultValue()"
              [hint]="field().helpText || ''"
              [appearance]="inputAppearance()"
              [readonly]="readonly()"
              [required]="isRequired()"
              [rows]="textareaRows()"
              [resize]="textareaResize()" />
          }

          @if (textareaShowCharacterCount() && textareaCharacterLimit()) {
            <div class="mt-1 text-right text-xs text-slate-400">
              Max {{ textareaCharacterLimit() }} characters
            </div>
          }
        </div>
      }
      @case ('select') {
        @if (isCollectionBackedSelect()) {
          @if (hasAnswerBinding()) {
            <lib-signal-dropdown
              [label]="field().label"
              placeholder="Select an option"
              [hint]="field().helpText || ''"
              [items]="collectionSelectItems()"
              valuePath="id"
              displayPath="display"
              [value]="collectionSelectValue()"
              [appearance]="inputAppearance()"
              [required]="isRequired()"
              (valueChange)="onCollectionSelectChange($event)" />
          } @else {
            <lib-signal-dropdown
              [label]="field().label"
              placeholder="Select an option"
              [hint]="field().helpText || ''"
              [items]="collectionSelectItems()"
              valuePath="id"
              displayPath="display"
              [appearance]="inputAppearance()"
              [readonly]="readonly()"
              [required]="isRequired()" />
          }
        } @else if (hasAnswerBinding()) {
          <lib-signal-dropdown
            [formField]="$any(answerField())"
            [label]="field().label"
            placeholder="Select an option"
            [hint]="field().helpText || ''"
            [items]="manualDropdownItems()"
            valuePath="value"
            displayPath="label"
            [appearance]="inputAppearance()" />
        } @else {
          <lib-signal-dropdown
            [label]="field().label"
            placeholder="Select an option"
            [hint]="field().helpText || ''"
            [items]="manualDropdownItems()"
            [value]="selectDefaultValue()"
            valuePath="value"
            displayPath="label"
            [appearance]="inputAppearance()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('searchable_picker') {
        <div class="flex flex-col gap-1.5">
          <label class="text-sm font-medium text-slate-800">
            {{ field().label }}
            @if (isRequired()) {
              <span class="text-rose-500">*</span>
            }
          </label>
          <button
            type="button"
            class="flex w-full cursor-pointer items-center gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-left transition hover:border-slate-300 hover:bg-slate-50"
            (click)="openSearchablePicker()">
            <span class="min-w-0 flex-1">
              @if (searchablePickerPrimary()) {
                <span class="block truncate text-sm font-medium text-slate-900">
                  {{ searchablePickerPrimary() }}
                </span>
                @if (searchablePickerSecondary()) {
                  <span class="block truncate text-xs text-slate-500">
                    {{ searchablePickerSecondary() }}
                  </span>
                }
              } @else {
                <span class="block truncate text-sm text-slate-400">
                  {{ placeholder() || 'Search and select…' }}
                </span>
              }
            </span>
            <app-svg-icon
              class="shrink-0 text-slate-400"
              src="assets/icons/search.svg"
              [size]="18" />
          </button>
          @if (field().helpText) {
            <p class="text-xs text-slate-500">{{ field().helpText }}</p>
          }
          @if (answerFieldError()) {
            <p class="text-xs text-rose-600">{{ answerFieldError() }}</p>
          }
        </div>
      }
      @case ('single_choice') {
        @if (hasAnswerBinding() && !isFieldDisabled()) {
          <lib-signal-single-choice
            [options]="singleChoiceOptions()"
            [description]="field().helpText || ''"
            [formField]="$any(answerField())"
            [label]="field().label" />
        } @else {
          <lib-signal-single-choice
            [label]="field().label"
            [description]="field().helpText || ''"
            [options]="singleChoiceOptions()"
            [value]="singleChoiceDisplayValue()"
            [readonly]="readonly() || isFieldDisabled()"
            [disabled]="isFieldDisabled()"
            [required]="isRequired()" />
        }
      }
      @case ('multi_choice') {
        @if (hasAnswerBinding() && !isFieldDisabled()) {
          <app-multi-choice
            [options]="multiChoiceOptions()"
            [helpText]="field().helpText || ''"
            [formField]="$any(answerField())"
            [collectionAnswers]="isCollectionBackedMultiChoice()"
            [label]="field().label" />
        } @else {
          <app-multi-choice
            [label]="field().label"
            [helpText]="field().helpText || ''"
            [options]="multiChoiceOptions()"
            [collectionAnswers]="isCollectionBackedMultiChoice()"
            [value]="multiChoiceDisplayValue()"
            [readonly]="readonly() || isFieldDisabled()"
            [disabled]="isFieldDisabled()"
            [required]="isRequired()" />
        }
      }
      @case ('checkbox') {
        @if (hasAnswerBinding()) {
          <lib-signal-checkbox
            [formField]="$any(answerField())"
            [label]="field().label"
            [hint]="field().helpText || ''" />
        } @else {
          <lib-signal-checkbox
            [label]="field().label"
            [hint]="field().helpText || ''"
            [value]="checkboxDefaultValue()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('checkbox_group') {
        <div class="w-full">
          <div class="mb-2">
            <label class="text-sm font-medium text-slate-700">
              {{ field().label }}
              @if (isRequired()) {
                <span class="text-red-500">*</span>
              }
            </label>

            @if (field().helpText) {
              <p class="mt-1 text-xs text-slate-500">
                {{ field().helpText }}
              </p>
            }
          </div>

          <div class="flex flex-col gap-2">
            @for (option of field().options ?? []; track option) {
              @if (hasAnswerBinding()) {
                <lib-signal-checkbox
                  [label]="option"
                  [value]="isCheckboxOptionSelected(option)"
                  (valueChange)="onCheckboxOptionChange(option, $event)" />
              } @else {
                <lib-signal-checkbox
                  [label]="option"
                  [readonly]="readonly()" />
              }
            }
          </div>

          @if (answerFieldError()) {
            <p class="mt-1.5 text-xs text-red-600">{{ answerFieldError() }}</p>
          }
        </div>
      }
      @case ('date') {
        @if (hasAnswerBinding()) {
          <lib-signal-date-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [hint]="field().helpText || ''"
            [appearance]="inputAppearance()"
            [dateFormat]="signalDateFormat()" />
        } @else {
          <lib-signal-date-field
            [label]="field().label"
            [hint]="field().helpText || ''"
            [value]="field().dateDefault ?? null"
            [appearance]="inputAppearance()"
            [readonly]="readonly()"
            [required]="isRequired()"
            [dateFormat]="signalDateFormat()" />
        }
      }
      @case ('email') {
        @if (hasAnswerBinding()) {
          <lib-signal-text-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="placeholder() || 'name@example.com'"
            [hint]="field().helpText || ''"
            inputType="email"
            [appearance]="inputAppearance()" />
        } @else {
          <lib-signal-text-field
            [label]="field().label"
            [placeholder]="placeholder() || 'name@example.com'"
            [hint]="field().helpText || ''"
            inputType="email"
            [appearance]="inputAppearance()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('phone') {
        @if (hasAnswerBinding()) {
          <lib-signal-phone-number-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="placeholder()"
            [hint]="field().helpText || ''"
            [appearance]="inputAppearance()" />
        } @else {
          <lib-signal-phone-number-field
            [label]="field().label"
            [placeholder]="placeholder()"
            [hint]="field().helpText || ''"
            [appearance]="inputAppearance()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('number') {
        @if (hasAnswerBinding()) {
          <lib-signal-number-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="numberPlaceholder()"
            [appearance]="inputAppearance()"
            [hint]="field().helpText || ''" />
        } @else {
          <lib-signal-number-field
            [label]="field().label"
            [placeholder]="numberPlaceholder()"
            [value]="numberDefaultValue()"
            [appearance]="inputAppearance()"
            [hint]="field().helpText || ''"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('currency') {
        @if (hasAnswerBinding() && !isFieldDisabled()) {
          <app-currency-input
            [formField]="$any(answerField())"
            [label]="field().label"
            [description]="field().helpText || ''"
            [defaultCurrency]="currencyDefaultCurrency()"
            [allowChangeCurrency]="currencyAllowChange()" />
        } @else {
          <app-currency-input
            [label]="field().label"
            [description]="field().helpText || ''"
            [defaultCurrency]="currencyDefaultCurrency()"
            [allowChangeCurrency]="currencyAllowChange()"
            [min]="currencyMin()"
            [max]="currencyMax()"
            [value]="currencyDefaultValue()"
            [readonly]="readonly() || isFieldDisabled()"
            [disabled]="isFieldDisabled()"
            [required]="isRequired()"
          />
        }
      }
      @case ('url') {
        @if (hasAnswerBinding()) {
          <lib-signal-text-field
            [formField]="$any(answerField())"
            inputType="url"
            [label]="field().label"
            [placeholder]="'https://company.com'"
            [prefixIcon]="'assets/icons/web.svg'"
            [appearance]="inputAppearance()"
            [hint]="field().helpText || ''" />
        } @else {
          <lib-signal-text-field
            inputType="url"
            [label]="field().label"
            [placeholder]="'https://company.com'"
            [prefixIcon]="'assets/icons/web.svg'"
            [appearance]="inputAppearance()"
            [hint]="field().helpText || ''"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('radio_group') {
        <div>
          @if (hasAnswerBinding()) {
            <lib-signal-radio-group
              [formField]="$any(answerField())"
              [label]="field().label"
              [hint]="field().helpText || ''"
              [options]="radioOptions()"
              [orientation]="field().orientation ?? 'vertical'" />
          } @else {
            <lib-signal-radio-group
              [label]="field().label"
              [hint]="field().helpText || ''"
              [options]="radioOptions()"
              [orientation]="field().orientation ?? 'vertical'"
              [required]="isRequired()"
              [readonly]="readonly()" />
          }
        </div>
      }
      @case ('switch') {
        @if (hasAnswerBinding()) {
          <lib-signal-switch
            [formField]="$any(answerField())"
            [label]="field().label"
            [hint]="field().helpText || ''" />
        } @else {
          <lib-signal-switch
            [label]="field().label"
            [hint]="field().helpText || ''"
            [value]="switchDefaultValue()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
      @case ('slider') {
        <div class="w-full">
          @if (hasAnswerBinding()) {
            <lib-signal-slider
              [formField]="$any(answerField())"
              [label]="field().label"
              [hint]="field().helpText ?? ''"
              [sliderMin]="sliderMin()"
              [sliderMax]="sliderMax()"
              [sliderStep]="sliderStep()" />
          } @else {
            <lib-signal-slider
              [label]="field().label"
              [hint]="field().helpText ?? ''"
              [sliderMin]="sliderMin()"
              [sliderMax]="sliderMax()"
              [sliderStep]="sliderStep()"
              [required]="isRequired()"
              [value]="sliderDefaultValue()"
              [readonly]="readonly()" />
          }
        </div>
      }
      @case ('image_picker') {
        <app-image-picker
          [label]="field().label"
          [allowCamera]="false"
          [helpText]="field().helpText || ''"
          [required]="isRequired()"
          [maxFileSize]="field().validation?.maxFileSize ?? null"
          (filesChange)="onImageFilesChange($event)" />
        @if (answerFieldError()) {
          <p class="mt-1.5 text-xs text-red-600">{{ answerFieldError() }}</p>
        }
      }
      @case ('camera') {
        <app-image-picker
          [label]="field().label"
          [allowCamera]="true"
          [helpText]="field().helpText || ''"
          [required]="isRequired()"
          [maxFileSize]="field().validation?.maxFileSize ?? null"
          (filesChange)="onImageFilesChange($event)" />
        @if (answerFieldError()) {
          <p class="mt-1.5 text-xs text-red-600">{{ answerFieldError() }}</p>
        }
      }
      @case ('file_uploader') {
        <app-image-picker
          [label]="field().label"
          [allowCamera]="false"
          [helpText]="field().helpText || 'Upload one or more files'"
          [required]="isRequired()"
          [maxFileSize]="field().validation?.maxFileSize ?? null"
          (filesChange)="onImageFilesChange($event)" />
        @if (answerFieldError()) {
          <p class="mt-1.5 text-xs text-red-600">{{ answerFieldError() }}</p>
        }
      }
      @case ('range_slider') {
        <div class="w-full">
          @if (hasAnswerBinding()) {
            <lib-signal-range-slider
              [formField]="$any(answerField())"
              [label]="field().label"
              [sliderMin]="sliderMin()"
              [sliderMax]="sliderMax()"
              [sliderStep]="sliderStep()"
              [hint]="field().helpText || ''"
              [showValueLabel]="true"
              [showValueBubble]="true" />
          } @else {
            <lib-signal-range-slider
              [label]="field().label"
              [sliderMin]="sliderMin()"
              [sliderMax]="sliderMax()"
              [sliderStep]="sliderStep()"
              [value]="rangeSliderDefaultValue()"
              [hint]="field().helpText || ''"
              [readonly]="readonly()"
              [required]="isRequired()"
              [showValueLabel]="true"
              [showValueBubble]="true" />
          }
        </div>
      }
      @case ('date_range') {
        @if (hasAnswerBinding()) {
          <lib-signal-date-range-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="field().placeholder ?? 'Select date range'"
            [hint]="field().helpText ?? ''"
            [minDate]="field().minDate ?? null"
            [maxDate]="field().maxDate ?? null"
            [allowOnlyPast]="field().dateRangeAllowOnlyPast ?? false"
            [allowOnlyFuture]="field().dateRangeAllowOnlyFuture ?? false"
            [allowToday]="field().dateRangeAllowToday ?? true"
            [disabledDays]="field().dateRangeDisabledDays ?? []"
            [disabledDates]="field().dateRangeDisabledDates ?? []"
            [showCalendarIcon]="field().dateRangeShowCalendarIcon ?? true"
            [showClearButton]="field().dateRangeShowClearButton ?? true"
            [scrollBehavior]="field().dateRangeScrollBehavior ?? 'reposition'"
            [mobilePresentation]="field().dateRangeMobilePresentation ?? 'modal'" />
        } @else {
          <lib-signal-date-range-field
            [value]="dateRangeValue()"
            [label]="field().label"
            [placeholder]="field().placeholder ?? 'Select date range'"
            [hint]="field().helpText ?? ''"
            [minDate]="field().minDate ?? null"
            [maxDate]="field().maxDate ?? null"
            [allowOnlyPast]="field().dateRangeAllowOnlyPast ?? false"
            [allowOnlyFuture]="field().dateRangeAllowOnlyFuture ?? false"
            [allowToday]="field().dateRangeAllowToday ?? true"
            [disabledDays]="field().dateRangeDisabledDays ?? []"
            [disabledDates]="field().dateRangeDisabledDates ?? []"
            [showCalendarIcon]="field().dateRangeShowCalendarIcon ?? true"
            [showClearButton]="field().dateRangeShowClearButton ?? true"
            [scrollBehavior]="field().dateRangeScrollBehavior ?? 'reposition'"
            [mobilePresentation]="field().dateRangeMobilePresentation ?? 'modal'"
            [required]="isRequired()" />
        }
      }
      @case ('address_selector') {
        @if (hasAnswerBinding()) {
          <app-google-address-auto-complete
            [formField]="$any(answerField())"
            [label]="field().label"
            [helpText]="field().helpText || ''" />
        } @else {
          <app-google-address-auto-complete
            [label]="field().label"
            [helpText]="field().helpText || ''"
            [required]="isRequired()" />
        }
      }
      @case ('multi_choice_grid') {
        @if (hasAnswerBinding() && !isFieldDisabled()) {
          <app-multi-choice-grid
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [items]="multiChoiceGridItems()"
            [options]="multiChoiceGridOptions()"
            [previewMode]="previewMode()"
            [responseType]="multiChoiceGridResponseType()"
            [formField]="$any(answerField())"
            [allowAdditionalRows]="multiChoiceGridAllowAdditionalRows()"
            [addRowButtonLabel]="multiChoiceGridAddRowButtonLabel()"
          />
        } @else {
          <app-multi-choice-grid
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [items]="multiChoiceGridItems()"
            [options]="multiChoiceGridOptions()"
            [responseType]="multiChoiceGridResponseType()"
            [value]="multiChoiceGridDisplayValue()"
            [required]="isRequired()"
            [readonly]="readonly()"
            [disabled]="readonly() || isFieldDisabled()"
            [allowAdditionalRows]="multiChoiceGridAllowAdditionalRows()"
            [addRowButtonLabel]="multiChoiceGridAddRowButtonLabel()"
          />
        }
      }
      @case ('single_choice_grid') {
        @if (hasAnswerBinding() && !isFieldDisabled()) {
          <app-single-choice-grid
            [formField]="$any(answerField())"
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [items]="singleChoiceGridItems()"
            [options]="singleChoiceGridOptions()"
            [responseType]="singleChoiceGridType()"
            [previewMode]="previewMode()"
            [allowAdditionalRows]="singleChoiceGridAllowAdditionalRows()"
            [addRowButtonLabel]="singleChoiceGridAddRowButtonLabel()"
          />
        } @else {
          <app-single-choice-grid
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [items]="singleChoiceGridItems()"
            [options]="singleChoiceGridOptions()"
            [responseType]="singleChoiceGridType()"
            [required]="isRequired()"
            [allowAdditionalRows]="singleChoiceGridAllowAdditionalRows()"
            [addRowButtonLabel]="singleChoiceGridAddRowButtonLabel()"
            [readonly]="readonly() || isFieldDisabled()"
            [disabled]="isFieldDisabled()"
          />
        }
      }
      @case ('map') {
        @if (hasAnswerBinding()) {
          <app-map-location-picker [formField]="$any(answerField())" [label]="field().label" />
        } @else {
          <app-map-location-picker [label]="field().label" [required]="isRequired()" />
        }
      }
      @case ('number_grid') {
        @if (hasAnswerBinding()) {
          <lib-number-grid
            [formField]="$any(answerField())"
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [columns]="numberGridColumns()"
            [items]="numberGridItems()"
            [previewMode]="previewMode()"
          />
        } @else {
          <lib-number-grid
            [label]="field().label"
            [helpText]="field().helpText ?? ''"
            [columns]="numberGridColumns()"
            [items]="numberGridItems()"
            [readonly]="readonly()"
            [disabled]="isFieldDisabled()"
            [required]="isRequired()"
            [previewMode]="previewMode()"
          />
        }
      }
      @default {
        @if (hasAnswerBinding()) {
          <lib-signal-text-field
            [formField]="$any(answerField())"
            [label]="field().label"
            [placeholder]="placeholder()"
            [hint]="field().helpText || ''"
            inputType="text"
            [appearance]="inputAppearance()" />
        } @else {
          <lib-signal-text-field
            [label]="field().label"
            [placeholder]="placeholder()"
            [hint]="field().helpText || ''"
            inputType="text"
            [appearance]="inputAppearance()"
            [readonly]="readonly()"
            [required]="isRequired()" />
        }
      }
    }
  }
</div>
